export default {"src":"/_next/static/media/AuditsAndVisits.46e8c419.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};